angular.module('lwNamb').controller('scopeToReactCtrl', [
  '$scope',
  function(
    $scope
  ) {

  },
]);
